import {
	Breadcrumb,
	BreadcrumbEllipsis,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
	HomeBreadcrumbItem,
} from '~/components/localized-breadcrumb'
import { useLingui } from '@lingui/react/macro'

export const AccountBreadcrumb = ({
	activePageTitle,
}: {
	activePageTitle: string
}) => {
	const { t } = useLingui()

	return (
		<Breadcrumb>
			<BreadcrumbList>
				<HomeBreadcrumbItem />

				<BreadcrumbSeparator />

				<BreadcrumbItem>
					<BreadcrumbLink
						href='/account'
						className='max-md:hidden'
					>
						{t`Mon compte`}
					</BreadcrumbLink>

					<BreadcrumbEllipsis className='md:hidden' />
				</BreadcrumbItem>

				<BreadcrumbSeparator />

				<BreadcrumbItem>
					<BreadcrumbPage>{activePageTitle}</BreadcrumbPage>
				</BreadcrumbItem>
			</BreadcrumbList>
		</Breadcrumb>
	)
}
